import { parseCookies } from 'nookies'

import { api } from '@/services/axios'

export interface CreateCampaignBody {
  titulo: string
  titulo_quantidade: number
  titulo_valor: number
  descricao: string
  prazo_id: number
  titulo_min: number
  titulo_max: number
  modo_id: number
  dt_sorteio?: string
  imagemFile: File
  notificar_grupo_whatsapp?: boolean
  nome_grupo_whatsapp?: string
  status: boolean
}

export async function createCampaigns(data: CreateCampaignBody) {
  const { 'reactAuth.id': userId } = parseCookies()
  const formData = new FormData()
  const valorTitulo = parseFloat(String(data.titulo_valor).replace(',', '.'))

  formData.append('Titulo', data.titulo)
  formData.append('Titulo_Quantidade', String(data.titulo_quantidade))
  formData.append('Titulo_Valor', valorTitulo.toString())
  formData.append('Descricao', data.descricao)
  formData.append('Prazo_Id', String(data.prazo_id))
  formData.append('Titulo_Min', String(data.titulo_min))
  formData.append('Titulo_Max', String(data.titulo_max))
  formData.append('Modo_Id', String(data.modo_id))
  formData.append('Usuario_Id', String(userId))
  formData.append('Fl_DataSorteio', (!!data.dt_sorteio).toString())

  if (data.dt_sorteio) {
    formData.append('Dt_Sorteio', data.dt_sorteio)
  }

  if (data.imagemFile) {
    formData.append('Imagem', data.imagemFile)
  }

  formData.append(
    'notificar_grupo_whatsapp',
    data.notificar_grupo_whatsapp ? 'true' : 'false',
  )
  formData.append('nome_grupo_whatsapp', data.nome_grupo_whatsapp || '')
  formData.append('status', (!!data.status).toString())

  await api.post('Campanha/Create', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
